module.exports = __webpack_public_path__ + "img/advisory.7606bc5d.svg";